import { render, staticRenderFns } from "./index.html?vue&type=template&id=5236c43b&scoped=true&external"
import script from "./XacMinhSMS.vue?vue&type=script&lang=js"
export * from "./XacMinhSMS.vue?vue&type=script&lang=js"
import style0 from "./XacMinhSMS.vue?vue&type=style&index=0&id=5236c43b&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5236c43b",
  null
  
)

export default component.exports